// create a hook to handle the form and send message to the backend
import { useState } from 'react';
import config from 'config/config';

const useContact = () => {
  const [valueForm, setValueForm] = useState({});
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isVerifiedRecaptcha, setIsVerifiedRecaptcha] = useState(false);

  const handleChange = (e) => {
    setValueForm({
      ...valueForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(false)
    setSuccess(false)
    // add code to send post using fetch with code 
    try{
        const send = await fetch(config.endPointContact, {
          method: 'POST',
          headers: {    
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(valueForm),
        });
        if(send.status === 200){
          setSuccess(true)
          setValueForm({
         
          })
        }else{
          setError(true)
        }
    }
    catch(err){
        setError(err)
    }finally{
        setLoading(false);
    }
  };

  const handleCaptchaSubmission = async (tokenRecaptcha) => {
      try {
          const response = await fetch(config.endPointVerifyRecaptcha, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
              },
              body: JSON.stringify({
                  token:tokenRecaptcha,
              }),
          });
      
          if (!response.ok) {
            throw new Error(`Request failed with status: ${response.status}`);
          }
      
          const data = await response.json();

          console.log("data", data);

          if (data.success) {
            setIsVerifiedRecaptcha(true);
          } else {
            setIsVerifiedRecaptcha(false);
          }
      } catch (err) {
          console.error("Error during reCAPTCHA verification:", err);
          setIsVerifiedRecaptcha(false);
      }
  }
  
  const handleExpiredRecaptcha = () => {
    setIsVerifiedRecaptcha(false);
  };

  return {
    error,
    loading,
    success,
    valueForm,
    isVerifiedRecaptcha,
    handleChange,
    handleSubmit,
    handleExpiredRecaptcha,
    handleCaptchaSubmission
  };
};

export default useContact;